import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { SubmitButtonComponent } from 'components/input/submit-button/submit-button.component';
import { DataRowComponent, DataTableComponent } from 'components/layout/data-table/data-table.component';
import { QuestionnaireModel } from 'models/generated/Entities.GormCrm.Questionnaire';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';
import { QuestionnaireService } from 'services/questionnaire.service';

@Component({
	selector: 'edit-questionnaire-name',
	templateUrl: './edit-questionnaire-name.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, DataTableComponent, DataRowComponent, CustomInputComponent, SubmitButtonComponent, TranslatePipe]
})
export class EditQuestionnaireNameComponent {

	private _questionnaire!: QuestionnaireModel;
	updatedQuestionnaireName = '';
	
	@Input()
	set questionnaire(questionnaire: QuestionnaireModel) {
		this._questionnaire = questionnaire;
		this.updatedQuestionnaireName = questionnaire.name;
	}
	get questionnaire() {
		return this._questionnaire;
	}

	constructor(private readonly questionnaireService: QuestionnaireService, private readonly navigation: NavigationService) { }

	saveQuestionnaire() {
		this.questionnaireService.updateQuestionnaireName(this.questionnaire.id!, this.updatedQuestionnaireName).then(_ => { this.navigation.closeView(this); });
	}
}
